import { useEffect, useRef, useState } from "react";
import { BiBlock, BiCopy, BiLockOpen, BiMessageAltError, BiTrash, BiTrashAlt } from "react-icons/bi";
import { FaReply } from "react-icons/fa";
import { GoMute, GoUnmute } from "react-icons/go";
import { LuLoader } from "react-icons/lu";
import { MdMoreVert } from "react-icons/md";
import { PiPaperPlaneTilt } from "react-icons/pi";
import Swal from "sweetalert2";
import Api from "../../../service/http";
import { useSocket } from "../../../service/SocketProvider";

const MessageAction = ({ message, isSender, setReply }) => {
  const [modalPosition, setModalPosition] = useState(isSender ? "-top-[13vh]" : "-top-[18vh]"); //top-full
  // const handleContextMenu = (event) => {
  //   event.preventDefault();
  //   console.log("event.clientY", event?.clientY);
  //   console.log("window.innerHeight", window.innerHeight);
  //   const isBelowCenter = event?.clientY > window.innerHeight / 2;
  //   if (isBelowCenter) {
  //     setModalPosition("-top-[20vh]");
  //   }
  // };

  // useEffect(() => {
  //   document.addEventListener("contextmenu", handleContextMenu);
  //   return () => {
  //     document.removeEventListener("contextmenu", handleContextMenu);
  //   };
  // }, []);


  const [loading, setLoading] = useState(false);
  const [showActions, setShowActions] = useState(false);
  const actionRef = useRef(null);

  const userId = JSON.parse(localStorage.getItem("user"))?.id || null;

  const { socketSend } = useSocket();

  const onClickAction = async (action) => {
    if (loading) return; // Prevent multiple clicks
    setLoading(true);
    var res = null;
    var params = {};
    var isWebFetchMessage = false;
    var isWebFetchAllChats = false;

    switch (action) {
      case 'reply':
        setReply(message);
        break;
      case 'copy':
        navigator.clipboard.writeText(message?.message || "");
        break;
      case 'delete':
        params = { type: "delete" };
        isWebFetchMessage = true;
        break;
      case 'mute':
        params = { type: message?.is_mute ? "unmute" : "mute" };
        isWebFetchAllChats = true;
        break;
      case 'block':
        params = { type: message?.is_block ? "unblock" : "block" };
        isWebFetchAllChats = true;
        break;
      case 'report':
        const result = await Swal.fire({
          title: 'Are you sure you want to report this message?',
          text: 'This action will be reviewed by the admin.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Report',
          cancelButtonText: 'Cancel',
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6'
        });

        if (result.isConfirmed) {
          params = { type: "report" };
          isWebFetchMessage = true;
        }

        break;
      case 'unsend':
        params = { type: "unsend" };
        isWebFetchMessage = true;
        break;
      case 'permanently-delete':
        const resDelete = await Swal.fire({
          title: 'Are you sure you want to permanently delete this message?',
          text: 'This action cannot be undone.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Delete',
          cancelButtonText: 'Cancel',
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6'
        });

        if (resDelete.isConfirmed) {
          params = { type: "permanently-delete" };
          isWebFetchMessage = true;
        }

        break;
      default:
        console.log("Unknown action");
    }


    if (isWebFetchMessage) {
      res = await Api.post(`/web/chat/${message?.id}/action`, params);
      if (res?.data) {
        socketSend({
          type: "WebFetchMessage",
          user_id: userId,
          message: res?.data,
          isScroll: false,
        });
      }
    }

    if (isWebFetchAllChats) {
      res = await Api.post(`/web/chat/${message?.id}/action`, params);
      if (res?.data) {
        socketSend({
          type: "WebFetchChat",
          user_id: userId,
          message: res?.data,
          isScroll: false,
        });
      }
    }

    setShowActions(false);
    setLoading(false);
  }

  const buttons = [
    { id: 'reply', icon: <FaReply />, label: "Reply", isUnderLined: true, isDanger: false, showFor: 'both' },
    { id: 'copy', icon: <BiCopy />, label: "Copy", isUnderLined: true, isDanger: false, showFor: 'both' },
    { id: 'delete', icon: <BiTrash />, label: "Delete for me", isUnderLined: true, isDanger: false, showFor: 'both' },
    { id: 'mute', icon: message?.is_mute ? <GoUnmute /> : <GoMute />, label: message?.is_mute ? "Unmute" : "Mute", isUnderLined: true, isDanger: false, showFor: 'receiver' },
    { id: 'block', icon: message?.is_block ? <BiLockOpen color="red" /> : <BiBlock color="red" />, label: message?.is_block ? "Unblock" : "Block", isUnderLined: true, isDanger: true, showFor: 'receiver' },
    { id: 'report', icon: <BiMessageAltError color="red" />, label: "Report", isUnderLined: false, isDanger: true, showFor: 'receiver' },
    { id: 'unsend', icon: <PiPaperPlaneTilt />, label: "Unsend", isUnderLined: false, isDanger: false, showFor: 'sender' },
    { id: 'permanently-delete', icon: <BiTrashAlt />, label: "Permanently Delete", isUnderLined: false, isDanger: true, showFor: 'both' },
  ]

      // Close modal when clicking outside
      useEffect(() => {
        const handleClickOutside = (event) => {
          if (actionRef.current && !actionRef.current.contains(event.target)) {
            setShowActions(false);
          }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
          document.removeEventListener("mousedown", handleClickOutside);
        };
      }, []);

    return (
      <div className="relative px-1" ref={actionRef}>
            <button
                onClick={() => setShowActions(!showActions)}
                className="p-1 rounded-full hover:bg-gray-100 transition-colors text-gray-400"
            >
              <MdMoreVert size={20} />
            </button>

            {/* Modal */}
            {showActions && 
          <div className={`absolute ${modalPosition} bg-white shadow-xl border border-gray-100 rounded-xl p-2 z-50 w-max ${isSender ? "right-0" : "left-0"}`}
              >
                {buttons?.map((button, index) => 
                <>
                    {((isSender && (button?.showFor == 'both' || button?.showFor == 'sender')) || (!isSender && (button?.showFor == 'both' || button?.showFor == 'receiver'))) &&
                    <>
                    <div

                    onClick={() => onClickAction(button?.id)}
                        className="w-full flex text-left text-sm text-gray-700 hover:bg-gray-100 rounded p-1 cursor-pointer"
                    >
                    <div className="flex items-center justify-center gap-1">
                          <div>{loading ?
                            <LuLoader className="animate-spin" /> : button?.icon}</div>
                        <div className={`${button?.isDanger ? "text-red-500" : ""}`}>{button?.label}</div>
                    </div>
                    </div>
                      {button?.isUnderLined && <hr className="w-full" />}
                    </>
                    }
                </>
                )}
              </div>
            }
          </div>
    )
}

export default MessageAction;